import { Film } from "lucide-react";

export default function CreateMiddlePanel({
  slides,
  activeSlide,
  slidesAnimationData,
}) {
  const currentSlide = activeSlide !== null ? slides[activeSlide] : null;

  return (
    <div className="col-span-6 bg-white rounded-2xl shadow p-6 flex items-center justify-center">
      <div className="w-full h-[30rem] border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50 overflow-hidden relative">
        {currentSlide && !currentSlide.is_active && (
          <div className="absolute top-4 left-4 bg-gray-500 text-white text-[11px] px-2 py-1 rounded-md font-bold z-30 flex items-center gap-1.5 shadow-md">
            <div className="w-1.5 h-1.5 bg-gray-300 rounded-full animate-pulse"></div>
            HIDDEN
          </div>
        )}

        <div
          className={`w-full h-full flex items-center justify-center ${
            currentSlide && !currentSlide.is_active
              ? "opacity-40 grayscale-[0.7]"
              : ""
          }`}
        >
          {currentSlide ? (
            <>
              {/* Image Slide */}
              {currentSlide.type === "image" && (
                <img
                  src={
                    currentSlide.imageUrl ||
                    (currentSlide.image instanceof File
                      ? URL.createObjectURL(currentSlide.image)
                      : currentSlide.image)
                  }
                  alt={currentSlide.image_title}
                  className="object-contain w-full h-full"
                />
              )}

              {/* Blank Animated Slide */}
              {currentSlide.type === "blank" && (
                <div
                  className="w-full h-full flex flex-col items-center justify-center gap-2"
                  style={{
                    backgroundColor:
                      slidesAnimationData[activeSlide]?.canvasBackgroundColor ||
                      "#1a1a2e",
                  }}
                >
                  <Film className="w-10 h-10 text-white/30" />
                  <p className="text-white/40 text-sm font-medium">
                    Animated Slide
                  </p>
                  <p className="text-white/25 text-xs">
                    Open the Animation Editor to add elements
                  </p>
                </div>
              )}

              {/* Text Question */}
              {currentSlide.question_type === "text" && (
                <div className="p-6 w-full">
                  <p className="font-bold text-xl mb-4 ml-1 text-black">
                    {currentSlide.title}
                  </p>

                  <h2 className="text-xl font-bold mb-4 ml-1">
                    {currentSlide.question}
                  </h2>

                  <textarea
                    placeholder="Your answer..."
                    className="w-full border rounded p-2 min-h-[100px]"
                  />
                </div>
              )}

              {/* Poll / Multiple Choice */}
              {(currentSlide.question_type === "multiple" ||
                currentSlide.question_type === "poll") && (
                <div className="p-6 w-full">
                  <p className="font-bold text-xl mb-4 ml-1 text-black">
                    {currentSlide.title}
                  </p>

                  <h2 className="text-xl font-bold mb-4 ml-1">
                    {currentSlide.question}
                  </h2>

                  <ul>
                    {currentSlide.choices?.map((choice, i) => (
                      <li
                        key={i}
                        className="p-2 border rounded-md hover:bg-gray-100 cursor-pointer flex items-center space-x-2 my-5"
                      >
                        <input
                          readOnly
                          type={
                            currentSlide.question_type === "poll"
                              ? "radio"
                              : "checkbox"
                          }
                          name={`choice-${currentSlide.id}`}
                          id={`choice-${i}`}
                          value={choice.choice_text || choice}
                          className={`h-4 w-4 ${
                            currentSlide.question_type === "poll"
                              ? "form-radio"
                              : "form-checkbox"
                          } text-lightPurple`}
                        />

                        <label
                          htmlFor={`choice-${i}`}
                          className="text-gray-700"
                        >
                          {choice.choice_text || choice}
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          ) : (
            <span className="text-gray-500">Slide Preview</span>
          )}
        </div>
      </div>
    </div>
  );
}
